import React from 'react';
import {Icon, Box, Text, Heading} from '@spothero/ui';
import IconStar from '@spothero/icons/star';
import {
    reviewAreaStyleProps,
    reviewerStyleProps,
    reviewTextStyleProps,
    reviewStyleProps,
    reviewAreaTitleStyleProps,
} from './ReviewAreaStyleProps';

/** This section is being hardCoded for the MVP -- future iteration will allow for dynamic ReviewItems rather than the usage below*/
function ReviewArea() {
    return (
        <Box {...reviewAreaStyleProps}>
            <Heading as="h4" {...reviewAreaTitleStyleProps}>
                What customers are saying about SpotHero
            </Heading>
            <Box {...reviewStyleProps}>
                <Text {...reviewerStyleProps}>Rosemarie G.</Text>
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Text {...reviewTextStyleProps}>
                    Very easy app to use. They provide great parking discounts
                </Text>
            </Box>
            <Box {...reviewStyleProps}>
                <Text {...reviewerStyleProps}>Stacy R.</Text>
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Icon as={IconStar} />
                <Text {...reviewTextStyleProps}>
                    Great app, I can always find reasonable parking. The parking
                    instructions are always clear.
                </Text>
            </Box>
        </Box>
    );
}
export default ReviewArea;
